export const MAX_LENGTHS = {
    FIRST_NAME: 50,
    LAST_NAME: 50,
};
